import ParserConfig from "./ParserConfig";

const GatewayParserConfig = () => {
  return <ParserConfig deviceTypeId={2} />;
};

export default GatewayParserConfig;
